var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.687,
    height: 14.459,
    viewBox: "0 0 18.687 14.459",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-1{fill:#fff}\r\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3639",
    transform: "translate(-7.553 -9.711)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2324",
    transform: "translate(7.553 9.711)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7818",
    d: "M97.463 22.7a1.027 1.027 0 0 0 0 .592 9.705 9.705 0 0 0 18.6 0 1.041 1.041 0 0 0 0-.592 9.721 9.721 0 0 0-9.286-6.934 9.728 9.728 0 0 0-9.314 6.934zm6.164-4.177A7.626 7.626 0 0 1 113.9 22.77l.082.218-.081.219a7.631 7.631 0 0 1-14.276 0l-.081-.219.082-.218a7.573 7.573 0 0 1 4.001-4.252z",
    className: "cls-1",
    transform: "translate(-97.42 -15.76)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_90",
    cx: 2.803,
    cy: 2.803,
    r: 2.803,
    className: "cls-1",
    transform: "translate(6.541 4.428)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreview);
export default __webpack_public_path__ + "static/media/preview.224c199c.svg";
export { ForwardRef as ReactComponent };